import Environment from '@interfaces/environment.interface'
import onEnvironmentChange from '@observables/environment.observable'
import { Axios, AxiosResponse } from 'axios'
import { take } from 'rxjs/operators'
import LogService from '../log/log.service'

export default class NpsService {
  url: string
  logService = new LogService()
  http: any

  constructor(npsUrl?: string, http?: Axios) {
    if (http) {
      this.http = http
    }
    if (!npsUrl) {
      onEnvironmentChange?.pipe(take(1)).subscribe((environment: Environment) => {
        this.url = environment?.squidApis?.nps
      })
    } else {
      this.url = npsUrl
    }
    this.logService.init('NPS Service')
  }

  public async getNPSInfos({ campaignId, token }: { campaignId: string; token: string }): Promise<any> {
    return this.http
      .get(`${this.url}/research/${campaignId}`, {
        headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
      })
      .then((r: AxiosResponse) => r.data)
      .catch((error: any) => {
        this.logService.error({
          message: 'Error on get NPS infos ',
          error,
        })
        throw error.response
      })
  }

  public async sendAnswer({
    researchId,
    questionId,
    token,
    answer,
    score,
  }: {
    researchId: string
    questionId: string
    token: string
    answer: string
    score: number
  }): Promise<{ success: boolean }> {
    return this.http
      .post(
        `${this.url}/research/${researchId}/question/${questionId}/answer`,
        { answer, score },
        {
          headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
        }
      )
      .then((r: AxiosResponse) => r.data)
      .catch((error: any) => {
        this.logService.error({
          message: 'Error on send answer ',
          error,
        })
        throw error.response
      })
  }
}
